import { motion } from 'framer-motion';
import styled from 'styled-components';
import StyleGuide from 'src/style-guide';
import theme from 'src/theme';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;
const rowSidePadding = 40;
const screenshotWidth = 150;
const screenshotHeight = 100;

export const ScreenshotImage = styled(motion.div)<{ thumbnail: string }>`
  position: relative;
  width: ${screenshotWidth}px;
  height: ${screenshotHeight}px;
  margin-bottom: 8px;
  background-image: url('${({ thumbnail }) => thumbnail}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: black;
  cursor: pointer;
`;

export const InProgressContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  color: #cccccc;
`;

export const PercentDoneTray = styled.div`
  height: 8px;
  width: 100%;
  background-color: #c4c4c4;
`;

export const PercentDoneMeter = styled('div')<{ percentDone: number }>`
  background-color: #6e7694;
  height: 8px;
  width: ${({ percentDone }) => percentDone}%;
`;

export const InProgressCopy = styled.div`
  padding: 36px 0;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
`;

export const SpinnerBG = styled('div')`
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  padding: 36px 0;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
`;

export const AlertIcon = styled(StyleGuide.Icon)`
  display: block;
  top: 20px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  svg {
    height: 18px;
    width: 21px;
  }
`;

export const HdBanner = styled('div')`
  width: 100%;
  height: 100%;

  &:before {
    color: #0d1a4c;
    width: 34px;
    height: 20px;
    background-color: rgba(249, 252, 255, 0.9);
    content: 'HD';
    position: absolute;
    top: 4px;
    right: 4px;
    font-family: Gotham Bold;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
  }
`;

export const FailedBG = styled('div')`
  height: 100%;
  font-family: Gotham Bold;
  font-size: 14px;
  background-color: rgba(255, 255, 255, 0.8);
  color: black;
`;

export const ErrorMessage = styled('div')`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
  top: 45px;
`;

export const Row = styled('div')`
  position: relative;
  display: flex;
  padding: 24px ${rowSidePadding}px 74px;
  flex: 1;
  justify-content: space-between;

  @media ${DEVICE.DESKTOP_PORTRAIT} {
    justify-content: space-around;
    flex: unset;
    width: 100%;
  }
`;

export const Line = styled('div')`
  position: absolute;
  width: 326px;
  height: 0;
  border-bottom: 1px solid #d5d5d5;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  @media ${DEVICE.DESKTOP_PORTRAIT} {
    width: 90%;
  }
`;

export const DeleteButton = styled('div')`
  position: absolute;
  right: 40px;
  bottom: 32px;
  width: 76px;
  height: 26px;
  padding: 4px 0;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #247ddc;
  background-color: ${theme.colors.white};
  color: #247ddc;
  cursor: pointer;

  @media ${DEVICE.DESKTOP_PORTRAIT} {
    right: calc(
      (100% - ${rowSidePadding * 2}px - ${screenshotWidth * 2}px) / 4 +
        ${rowSidePadding}px
    );
  }
`;

export const EnhancedScreenshotImage = styled(motion.div)<{
  thumbnail: string;
  isRenderingComplete: boolean;
}>`
  position: relative;
  width: ${screenshotWidth}px;
  height: ${screenshotHeight}px;
  margin-bottom: 8px;
  background-image: url('${({ thumbnail }) => thumbnail}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: black;
  overflow: hidden;
  cursor: ${({ isRenderingComplete }) =>
    isRenderingComplete ? 'pointer' : 'auto'};
`;
